/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 34,
  image: "default-changelog-v2.png",
  title: "Encryption support on Storage & Browser SDK's, Improvements & Fixes on the Platform",
  shortDescription: "We have added  support for Encryption and Decryption on Storage & Browser SDK. Released a new version of the Spheron platform with new Features and Improvements",
  description: "We have added  support for Encryption and Decryption on Storage & Browser SDK.  Released a new version of the Spheron platform with new Features and Improvements",
  date: "June 16th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Storage", "SDK", "Browser-Upload", "CLI"]
};
export const content = `
## Encryption Support on Storage & Browser SDK’s
- We are excited to announce the release of a new version of [@spheron/storage](https://www.npmjs.com/package/@spheron/storage) and [@spheron/browser-upload](https://www.npmjs.com/package/@spheron/browser-upload) SDKs with enhanced security features. This update includes encryption and access control support powered by Lit Protocol's distributed key management layer.
- With this release, clients can now encrypt and decrypt data on the client side using on or off-chain conditions. This approach eliminates the need for a centralized key custodian and ensures secure data storage on the Open Web, such as IPFS, thereby enhancing security and privacy.
- Please refer to the updated updated [Storage](https://docs.spheron.network/sdk/storage/#encrypt-upload) and [Browser-Upload](https://docs.spheron.network/sdk/browser/#encrypt-upload) documentation.

### Access Control Conditions

- Access control conditions have been introduced to provide flexible control over data access. The following examples demonstrate the versatility of these conditions:

  - Membership gating within a particular DAO.
  - Ownership of a specific ERC-721 or ERC-20 token.
  - The result of any smart contract or API call, including actions like following on Twitter.

- Access Control Conditions are compatible with most EVM chains, Cosmos, and Solana.

- [Lit Protocol](https://dfeveloper.litprotocol.com/) powers the access control conditions. For more information and implementation details, please refer to the [docs](https://developer.litprotocol.com/accessControl/intro).

## Improvements & Fixes

- **Arweave HTML Routing Issue:** Fixed the issue with the routing of the uploaded HTML files on Arweave.
- **IPNS Support:** Added IPNS support for dedicated gateways.
- **Authorized Deployments:** Fixed the issue of authorized deployments timing out sooner than expected.
- **Query Parameters For Cluster Domains:** Resolved the issue of query parameters not being passed when using cluster domains.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
